
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 21v-8a12 12 0 1124 0v8","stroke":"#000","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25 22.333A2.667 2.667 0 0122.333 25H21a2.667 2.667 0 01-2.667-2.667v-4A2.667 2.667 0 0121 15.667h4v6.666zm-24 0A2.667 2.667 0 003.667 25H5a2.667 2.667 0 002.667-2.667v-4A2.667 2.667 0 005 15.667H1v6.666z","stroke":"#000","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    